class SubscriptionPopup extends HTMLElement {
  constructor() {
    super();
    
    if (window.location.pathname === '/challenge') {
      return;
    }
    this.cookieName = 'fusion:subscription-popup';
    this.popup = this;
    this.classes = {
      bodyClass: 'subscription-modal-open',
      overlayCLass:"overflow-hidden",
      activeClass: 'is-visible',
      closingClass: 'closing',
    };
    this.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    this.bindForm();

    // Re-open after the form posts so the customer sees the code or the error
    if (this.querySelector('.form-success-message')) {
      this.classList.add('is-success');
      this.setCookie(this.cookieName, 365);
      this.open();
      return;
    }
    if (this.querySelector('.form-error-message')) {
      this.open();
      return;
    }

    if (!this.getCookie(this.cookieName)) {
      this.init();
    }
  }
  bindForm() {
    const form = this.querySelector('form.signup-form');
    if (form) {
      form.addEventListener('submit', () => {
        const fullName = form.querySelector('[data-full-name]');
        if (fullName) {
          const parts = fullName.value.trim().split(/\s+/);
          form.querySelector('[data-first-name]').value = parts.shift() || '';
          form.querySelector('[data-last-name]').value = parts.join(' ');
        }
        const phone = form.querySelector('[data-phone]');
        if (phone) phone.value = this.normalizePhone(phone.value, form.dataset.phonePrefix || '');
      });
    }

    const copyBtn = this.querySelector('[data-copy-code]');
    const code = this.querySelector('[data-discount-code]');
    if (copyBtn && code) {
      copyBtn.addEventListener('click', () => {
        const text = code.textContent.trim();
        const done = () => {
          copyBtn.textContent = 'Copied!';
          setTimeout(() => (copyBtn.textContent = 'Copy code'), 2000);
        };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(done);
        } else {
          const range = document.createRange();
          range.selectNodeContents(code);
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
          document.execCommand('copy');
          done();
        }
      });
    }
  }
  // Shopify only accepts E.164 numbers, so turn local numbers like 01012345678 into +201012345678
  normalizePhone(value, prefix) {
    let phone = value.replace(/[^\d+]/g, '');
    if (!phone) return phone;
    if (phone.startsWith('00')) return '+' + phone.slice(2);
    if (phone.startsWith('+')) return phone;
    const code = prefix.replace(/[^\d]/g, '');
    if (code && phone.startsWith(code) && phone.length > 11) return '+' + phone;
    return '+' + code + phone.replace(/^0/, '');
  }
  init() {
    if(!this.popup) {
      return;
    }

    setTimeout(function() {
      this.open();
      
    }.bind(this), parseInt(2) * 1000);
  }
  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }
  open() {
    document.body.classList.remove(this.classes.bodyClass);
    if (this.dataset.subscriptionpopup == 'true') {
      document.body.classList.add(this.classes.bodyClass);
      this.popup.classList.add(this.classes.activeClass);
       document.body.classList.add(this.classes.overlayCLass);
    }
  }
  close() {
    this.popup.classList.add(this.classes.closingClass);
     document.body.classList.remove(this.classes.overlayCLass);
    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);

    }, 500);

  
    this.setCookie(this.cookieName, this.dataset.expiry);
  }
  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }
  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('subscription-popup', SubscriptionPopup);
